import PropTypes from 'prop-types';

const MarketType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
});

export default MarketType;



// WEBPACK FOOTER //
// ./client/app/shared/types/market.js